__turbopack_context__.v({
  "block": "FormFactorsSection-module__m7Jo6G__block",
  "blockDark": "FormFactorsSection-module__m7Jo6G__blockDark",
  "blockLight": "FormFactorsSection-module__m7Jo6G__blockLight",
  "headline": "FormFactorsSection-module__m7Jo6G__headline",
  "inner": "FormFactorsSection-module__m7Jo6G__inner",
  "root": "FormFactorsSection-module__m7Jo6G__root",
  "stickySlot": "FormFactorsSection-module__m7Jo6G__stickySlot",
  "title": "FormFactorsSection-module__m7Jo6G__title",
});
